export default "__VITE_ASSET__BVhmI5IQ__"